export const setFieldValue=(value,name,formFields)=>{

    console.log('setFieldValues name :', name,value);
    let isValidated=true;
     {formFields.map(f=>{
      const {getField}={...f};
  
  if(f.name===name){
      getField.value=value;
      const options=getField.options;
      if (getField.options.isRequired) {
        if (
          value === null ||
          value === undefined ||
          (getField.options.type==='string' && typeof value === 'string' && value.trim().length === 0) ||
          (getField.options.type==='number' && typeof value === 'number' && isNaN(value)) ||
         ( getField.options.type==='date' && !isValidDate(value))
        ) {
          options.isValidated = false;
          isValidated = false;
          console.log(name + ' validated: false');
        } else {
          options.isValidated = true;
          isValidated = true;
          console.log(name + ' validated: true');
        }
      }
      options.isTouched=true;
  
      f.setField({ ...f[name], ...getField });
  }
    })}
  
    return isValidated;
  }
  
  function isValidDate(value) {
    console.log('isValidDate :',value);
    return typeof value === 'object' && value instanceof Date && !isNaN(value);
  }